import {
  SET_SELECTED_DATE,
  SET_TIMING_SELECTED,
  SET_EMPLOYEE_SELECTED_ID,
  SET_APPOINTMENT_EMPLOYEE_DETAILS,
  SET_MODAL_ID,
  SET_EMPLOYEES_AND_SERVICE,
  SET_FROM,
  SET_CUSTOMER_DETAILS,
  SAVE_FORM_DATA,
  SET_CONTINUE_BOOKING_DATA,
  RESET_CONTINUE_BOOKING_DATA,
} from "../constants/ActionTypes";

export const dateChangeClick = payload => ({
  type: SET_SELECTED_DATE,
  payload,
});

export const timingSelectClick = payload => ({
  type: SET_TIMING_SELECTED,
  payload,
});

export const setEmployeeId = payload => ({
  type: SET_EMPLOYEE_SELECTED_ID,
  payload,
});

export const setAppointmentEmployeeDtails = payload => ({
  type: SET_APPOINTMENT_EMPLOYEE_DETAILS,
  payload,
});

export const chanegModal = payload => ({
  type: SET_MODAL_ID,
  payload,
});

export const setEmployeesAndServiceIds = payload => ({
  type: SET_EMPLOYEES_AND_SERVICE,
  payload,
});

export const setFrom = payload => ({
  type: SET_FROM,
  payload,
});

export const setCustomerDetails = payload => ({
  type: SET_CUSTOMER_DETAILS,
  payload,
});

export const saveFormData = payload => ({
  type: SAVE_FORM_DATA,
  payload,
});

export const getFormData = payload => ({
  type: GET_FORM_DATA,
  payload
})

export const setContinueBookingData = payload => ({
  type: SET_CONTINUE_BOOKING_DATA,
  payload
})

export const resetContinueBookingData = () => ({
  type: RESET_CONTINUE_BOOKING_DATA
})


// WEBPACK FOOTER //
// ./actions/Modal.js